import React from 'react'
import { useTranslation } from 'react-i18next'
import { Breadcrumbs, Crumb } from '@carsys/ui'

export const SettingsBreadCrumbs: React.FC<React.ComponentProps<typeof Breadcrumbs>> = ({ ...props }) => {
  const { t } = useTranslation()

  return (
    <Breadcrumbs {...props}>
      <Crumb data-testid='crumb-stats' key='crumb-stats' path='/stats' text={t('Stats.Title')} />
      <Crumb data-testid='crumb-stats-timesheet' key='crumb-stats-timesheet' path='/stats/timesheet' text={t('Stats.Timesheet.Title')} />
      <Crumb
        data-testid='crumb-stats-clocked-employees'
        key='crumb-stats-clocked-employees'
        path='/stats/clocked-employees'
        text={t('Stats.ClockedEmployees')}
      />
    </Breadcrumbs>
  )
}

export default SettingsBreadCrumbs
